import { useCallback, useState } from 'react';
import { useLinkExterno } from '../../../link';
import { useDadosUsuario } from '../../../usuario/hooks';
import { autenticarTutoriaService } from '../../services/autenticar-tutoria/autenticar-tutoria.service';
import { AutenticarTutoriaHook, IAutenticarTutoriaProps } from './use-autenticar-tutoria.types';

export const useAutenticarTutoria: AutenticarTutoriaHook = () => {
  const { token, urlBase } = useDadosUsuario();
  const { acessarLinkExterno } = useLinkExterno();

  const [pendente, setPendente] = useState(false);
  const [erro, setErro] = useState(false);

  const autenticarTutoria = useCallback(
    (props: IAutenticarTutoriaProps = { destinoPaginaZeroDuvidas: undefined, idTurma: undefined }) => {
      const { destinoPaginaZeroDuvidas, idTurma } = props;
      setPendente(true);
      setErro(false);

      autenticarTutoriaService({ urlBase, token, destinoPaginaZeroDuvidas, idTurma })
        .then((data) => acessarLinkExterno(data.urlAutenticada, '_blank'))
        .catch(() => setErro(true))
        .finally(() => setPendente(false));
    },
    [acessarLinkExterno, token, urlBase],
  );

  return {
    pendente,
    erro,
    autenticarTutoria,
  };
};
